export default "__VITE_ASSET__C2CGZ3XA__"